module.exports = __webpack_public_path__ + "static/assets/718681b76ba421e7bab658a5533c4bd6.png";